import { SELECTORS } from './selectors';
import {
	getConditionRows,
	getFirstConditionRow,
	getRowElements,
	getModal,
	getAllContexts,
} from './dom';
import { initConditionSelect, resetSelect } from './select2';

const $ = jQuery;

/**
 * Is condition row set (has selected type)
 * @param $row
 */
export function isConditionSet($row) {
	const el = getRowElements($row);
	const value = el.type.val();
	return !!value && !value.startsWith('all__');
}

/**
 * Update UI for a condition row
 * @param $row
 * @param condition
 * @param ajax
 */
export function updateConditionRow($row, condition = {}, ajax = {}) {
	const el = getRowElements($row);
	const target = el.type.val();

	el.idsWrap.hide();
	resetSelect(el.ids);

	if (!target || target.startsWith('all__')) {
		return;
	}

	// Label
	const label = el.type.find('option:selected').text()?.trim() || 'Items';
	el.idsLabel.text(label);

	const object_type =
		condition.object_type ||
		el.type.find('option:selected').data('object-type');

	// Init Select2 (only for valid types)
	initConditionSelect(el.ids, {
		ajaxurl: ajax.ajaxurl,
		nonce: ajax.nonce,
		object_type,
		target,
		items: condition.items || [],
	});

	el.idsWrap.show();
}

export function addEmptyConditionRow() {
	const $rows = getConditionRows();
	const index = $rows.length;

	const $source = $rows.first();
	const $row = $source.clone(false, false);

	$row.attr('data-index', index);
	$row.find('.select2').remove();

	const el = getRowElements($row);

	el.type.val('');
	resetSelect(el.ids);
	el.idsWrap.hide();

	$row.insertAfter($rows.last());

	reindexConditionRows();
}

/**
 * Remove a condition row
 * @param $row
 */
export function removeConditionRow($row) {
	const index = parseInt($row.data('index'), 10);

	// Never remove first row
	if (index === 0) {
		return;
	}

	$row.remove();
	reindexConditionRows();
}

/**
 * Reindex all condition rows
 */
export function reindexConditionRows() {
	getConditionRows().each(function (index) {
		const $row = $(this);
		const el = getRowElements($row);

		$row.attr('data-index', index);

		// Update names
		$row.find('[name]').each(function () {
			const name = $(this).attr('name');
			if (!name) {
				return;
			}

			$(this).attr(
				'name',
				name.replace(/conditions\[\d+\]/, `conditions[${index}]`)
			);
		});

		// Toggle remove button visibility only
		if (index === 0) {
			el.remove.hide();
		} else {
			el.remove.show();
		}
	});
}

/**
 * Reset modal rows to single empty row
 * @param $context
 */
export function resetConditionRows($context) {
	$context.find(`${SELECTORS.row}:not(:first)`).remove();

	const $first = getFirstConditionRow($context);
	const el = getRowElements($first);

	el.type.val('');
	resetSelect(el.ids);
	el.idsWrap.hide();
}

export function resetPosition($context) {
	$context.find(SELECTORS.hook).val('');
	$context.find(SELECTORS.hookName).val('');
	$context.find(SELECTORS.priority).val(10);
}

export function resetModalFields() {
	const $modal = getModal();

	$modal.find(SELECTORS.context).removeClass('active');

	getAllContexts()
		.get()
		.forEach((el) => {
			resetPosition($(el));
			resetConditionRows($(el));
		});
}
